import React from "react";
import useViewerItemsVisibility from "@/hooks/viewer/use-viewer-items-visibility.ts";
import ViewerCanvas from "@/services/context/viewer/instance/viewer-canvas.tsx";

export const MeasureOverview3dViewerContainer: React.FC = () => {
    useViewerItemsVisibility();

    return (
        <div className='absolute inset-0'>
            <ViewerCanvas />
        </div>
    );
};

export default MeasureOverview3dViewerContainer;
